<script>
  export let id;
  export let green;
  export let gray;
  export let blue;
  export let greenLabel;
  export let grayLabel;
  export let blueLabel;
  export let backgroundColor = "white";
  export let thickness = 80;
  export let fontSize = "24px";

  let greenP = 0;
  let grayP = 100;
  let blueP = 0;

  const GREEN_COLOR = "#418040";
  const GRAY_COLOR = "#605E5C";
  const BLUE_COLOR = "#327EAA";

  let chart = null;

  let chartConfig = null;

  let calculateP = () => {
    greenP = 0;
    grayP = 100;
    blueP = 0;

    const num = green + gray + blue;
    if (num > 0) {
      greenP = Math.round((green / num) * 100);
      grayP = Math.round((gray / num) * 100);
      blueP = 100 - grayP - greenP;

      const data = {
        labels: [greenLabel, grayLabel, blueLabel],
        datasets: [
          {
            label: "Dataset",
            data: [green, gray, blue],
            backgroundColor: [GREEN_COLOR, GRAY_COLOR, BLUE_COLOR],
          },
        ],
      };

      chartConfig = {
        type: "doughnut",
        data: data,
        options: {
          responsive: true,
          legend: {
            display: false,
          },
          cutoutPercentage: thickness,
        },
      };

      let context = chart.getContext("2d");
      context.clearRect(0, 0, chart.width, chart.height);
      if (green > 0 || blue > 0 || gray > 0) {
        new Chart(chart, chartConfig);
      }
    }
  };

  $: if (green >= 0 && gray >= 0 && blue >= 0) {
    calculateP();
  }
</script>

<div class="taskChartContainer" style="background-color: {backgroundColor}">
  <canvas id={"task-" + id} bind:this={chart} width="100%" height="100%" />
  <div class="perc" style="font-size: {fontSize}">
    <!-- <span>{greenP}%</span> -->
    <span>{gray + blue}</span>
    <span class="messagePenTasks">Pending tasks</span>
  </div>
</div>

<style>
  div.taskChartContainer {
    width: 100%;
    height: 100%;
    position: relative;
    font-weight: bold;
    color: var(--labit-card-gray);
  }

  div.perc {
    position: absolute;
    top: 0px;
    left: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 50%;
    left: 50%;
    flex-direction: column;
    width: 70%;
    transform: translate(-50%, -50%);
  }

  .messagePenTasks {
    font-size: 15px;
    font-weight: normal;
  }
</style>
